import React from 'react';
import { UseFormReturn, FieldValues, FormProvider as RHFFormProvider } from 'react-hook-form';

/**
 * Form provider component that wraps React Hook Form's FormProvider
 * Provides form context to all child components
 */
interface FormProviderProps<TFieldValues extends FieldValues> {
  methods: UseFormReturn<TFieldValues>;
  onSubmit: (data: TFieldValues) => void;
  children: React.ReactNode;
}

export const FormProvider = <TFieldValues extends FieldValues>({
  methods,
  onSubmit,
  children,
}: FormProviderProps<TFieldValues>) => {
  return (
    <RHFFormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </RHFFormProvider>
  );
};

export default FormProvider;